import { searchRecipes } from '@/api/recipes'
import { Button } from '@/components/Button'
import { Spinner } from '@/components/Spinner'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generateRecipesHtml } from './generateRecipesHtml'

export default function ExportRecipesHtmlButton() {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const downloadFile = async () => {
    try {
      setLoading(true)
      const res = await searchRecipes({ page: 0, pageSize: 5000, model: 'EXTENDED' })
      const published = res.data.filter((r) => r.status === 'PUBLISHED')
      const html = generateRecipesHtml(published)
      const blob = new Blob([html], { type: 'text/html' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'recipes.html'
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Failed to export recipes:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Button style={{ marginLeft: '10px' }} variant="default" onPress={downloadFile}>
        {t('utils.download')}
      </Button>
      {loading && <Spinner />}
    </div>
  )
}
